import { DataProxy } from 'apollo-cache';
import { produce } from 'immer';
import { PagesQuery } from '../../generated/graphql';
import { pagesQuery } from '../../components/LeftContainer/graphql';

interface Args {
  pageId: number;
  cache: DataProxy;
  itemId: number;
}

function deletePageItem({ pageId, cache, itemId }: Args) {
  const { pages } = cache.readQuery<PagesQuery>({ query: pagesQuery })!;

  const updatedPages = produce(pages, draft => {
    const page = draft.find(p => p.id === pageId);

    if (page) {
      page.items = page.items || [];
      page.items = page.items.filter(pageItem => 'id' in pageItem && pageItem?.id !== itemId);
    }
  });

  cache.writeQuery({
    query: pagesQuery,
    data: { pages: updatedPages },
  });
}

export default deletePageItem;
